import { useReducer } from "react";
import { IActions } from "./configs";

const initialState = {
  height: 850,
  darkMode: true,
};

const reducer = (state: typeof initialState, action: IActions) => {
  switch (action.type) {
    case "SET_HEIGHT":
      return { ...state, height: action.payload };
    case "SET_DARK_MODE":
      return { ...state, darkMode: action.payload };
    default:
      return state;
  }
};

const useReducerActions = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setHeight = (height: number) => {
    dispatch({ type: "SET_HEIGHT", payload: height });
  };

  const setDarkMode = (darkMode: boolean) => {
    dispatch({ type: "SET_DARK_MODE", payload: darkMode });
  };

  return {
    actions: {
      setHeight,
      setDarkMode,
    },
    states: {
      ...state,
    },
  };
};

export default useReducerActions;
